export default __webpack_public_path__ + "static/SRF 3350ACS50PW - Fiche de spécifications et données techniques-e68ae6af4726214c326f9c3e60740fcd.pdf";